(function () {
  'use strict';

  var targetProduct = document.querySelector(
    '[data-product-id="gid://shopify/Product/9193659924708"]' +
    '[data-product-handle="eufycam-s4-2-cam-kit-e81721w1"]'
  );
  if (!targetProduct) return;

  function numberAttribute(input, name, fallback) {
    var raw = input.getAttribute(name);
    var value = raw === null || raw === '' ? NaN : Number(raw);
    return Number.isFinite(value) ? value : fallback;
  }

  function normalizedValue(input) {
    var min = numberAttribute(input, 'min', 1);
    var max = numberAttribute(input, 'max', Infinity);
    var value = Number(input.value);
    if (!Number.isFinite(value)) value = min;
    return Math.min(max, Math.max(min, value));
  }

  function syncControl(input) {
    if (!input) return;
    var control = input.closest('.cv-s4-quantity__control');
    if (!control) return;
    var minus = control.querySelector('[data-cv-s4-quantity-minus]');
    var plus = control.querySelector('[data-cv-s4-quantity-plus]');
    var min = numberAttribute(input, 'min', 1);
    var max = numberAttribute(input, 'max', Infinity);
    var value = normalizedValue(input);

    if (minus) {
      minus.disabled = value <= min;
      minus.setAttribute('aria-disabled', String(minus.disabled));
    }

    if (plus) {
      plus.disabled = value >= max;
      plus.setAttribute('aria-disabled', String(plus.disabled));
    }
  }

  function bind(root) {
    var input = root.querySelector('[data-cv-s4-quantity]');
    if (!input || input.dataset.cvS4RemediationReady === 'true') return;
    input.dataset.cvS4RemediationReady = 'true';

    ['input', 'change', 'blur', 'keyup'].forEach(function (eventName) {
      input.addEventListener(eventName, function () { syncControl(input); });
    });

    var control = input.closest('.cv-s4-quantity__control');
    if (control) {
      control.addEventListener('click', function () {
        window.requestAnimationFrame(function () { syncControl(input); });
      });
    }

    syncControl(input);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cv-s4-root]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  // The native widget keeps its own dialogue and keyboard behavior. Restore
  // focus after opening and Escape without adding a second focus trap.
  if (document.documentElement.dataset.cvS4AskVeroFocusBridgeReady !== 'true') {
    document.documentElement.dataset.cvS4AskVeroFocusBridgeReady = 'true';

    function afterWidgetSettles(callback) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(callback);
      });
    }

    document.addEventListener('click', function (event) {
      var chat = document.querySelector('clearvero-chat[data-product-id="gid://shopify/Product/9193659924708"]');
      if (!chat || !(event.target instanceof Element) ||
          !event.target.closest('clearvero-chat .cv-launcher')) return;

      afterWidgetSettles(function () {
        if (chat.getAttribute('data-open') !== 'true') return;
        var close = chat.querySelector('.cv-close');
        if (close) close.focus({ preventScroll: true });
      });
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var chat = document.querySelector('clearvero-chat[data-product-id="gid://shopify/Product/9193659924708"]');
      if (!chat || chat.getAttribute('data-open') !== 'true') return;

      afterWidgetSettles(function () {
        if (chat.getAttribute('data-open') !== 'false') return;
        var launcher = chat.querySelector('.cv-launcher');
        if (launcher) launcher.focus({ preventScroll: true });
      });
    }, true);

    var legalFooterObserver;
    var observedLegalFooter;

    function observeLegalFooter() {
      var legalFooter = document.querySelector('.cv-premium-footer__bottom');
      if (!legalFooter || legalFooter === observedLegalFooter ||
          !('IntersectionObserver' in window)) return;
      if (legalFooterObserver) legalFooterObserver.disconnect();
      observedLegalFooter = legalFooter;
      legalFooterObserver = new IntersectionObserver(function (entries) {
        var chat = document.querySelector('clearvero-chat[data-product-id="gid://shopify/Product/9193659924708"]');
        if (chat) chat.toggleAttribute('data-cv-s4-footer-legal-visible', entries[0].isIntersecting);
      });
      legalFooterObserver.observe(legalFooter);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeLegalFooter, { once: true });
    } else {
      observeLegalFooter();
    }
    document.addEventListener('shopify:section:load', observeLegalFooter);
  }

}());
